import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import SvgIconZoomIn from '@material-ui/icons/Add';
import SvgIconZoomOut from '@material-ui/icons/Remove';

import leaflet from 'leaflet';

import ControlButton from './ControlButton';

const styles = (theme) => {
    return {
        root: {
            backgroundColor: theme.palette.primary.main,
        },
        zoomOutButton: {
            marginTop: -1,
        },
    }
}

class ZoomControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allowZoomIn: true,
            allowZoomOut: true,
        }

        this.props.map.on({
            zoomend: this._handleZoomEnd,
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.map) {
            const z = nextProps.map.getZoom();

            return {
                allowZoomIn: (z < nextProps.map.getMaxZoom()),
                allowZoomOut: (z > nextProps.map.getMinZoom()),
            };
        }

        return null;
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.state.allowZoomIn !== nextState.allowZoomIn ||
            this.state.allowZoomOut !== nextState.allowZoomOut);
    }

    componentWillUnmount = () => {
        this.props.map.off({
            zoomend: this._handleZoomEnd,
        });
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div className={this.props.className}>
                <Paper
                    className={classes.root}
                    square={false}
                    elevation={2}
                >
                    <ControlButton
                        onClick={this._handleZoomIn}
                        disabled={!this.state.allowZoomIn}
                    >
                        <SvgIconZoomIn/>
                    </ControlButton>
                    <ControlButton
                        className={classes.zoomOutButton}
                        onClick={this._handleZoomOut}
                        disabled={!this.state.allowZoomOut}
                    >
                        <SvgIconZoomOut/>
                    </ControlButton>
                </Paper>
            </div>
        );
    }

    _handleZoomIn = () => {
        this.props.map.zoomIn();
    }

    _handleZoomOut = () => {
        this.props.map.zoomOut();
    }

    _handleZoomEnd = (e) => {
        const z = this.props.map.getZoom();

        if (z >= this.props.map.getMaxZoom()) {
            this.setState({allowZoomIn: false});
        } else {
            this.setState({allowZoomIn: true});
        }

        if (z <= this.props.map.getMinZoom()) {
            this.setState({allowZoomOut: false});
        } else {
            this.setState({allowZoomOut: true});
        }
    }
}

ZoomControl.propTypes = {
    map: PropTypes.instanceOf(leaflet.Map).isRequired,
}

export default withStyles(styles)(ZoomControl);
